import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { TargetApiRoutes } from '../enums/target-api-routes.enum'
import { Environment } from '../interfaces/environment.interface'
import { Filter } from '../interfaces/resources/filter.interface'
import { EnvironmentService } from './environment.service'
import { IncentiveFamily } from '../enums/incentive.family'

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  environment: Environment
  filtersLocalStorageKey = `InnotaxPersistentFilters`

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    this.environmentService.loadEnvironment().subscribe((env) => {
      this.environment = env
    })
  }

  list(params?: { dataset?: IncentiveFamily }): Promise<Filter[]> {
    return firstValueFrom(
      this.http.get(`${this.environment.apiBaseUrl}${TargetApiRoutes.Filters}`, {
        params
      })
    ).then((filterRes: Object) => {
      return filterRes as Filter[]
    })
  }

  getSavedFilters(): { [key: string]: string[] } {
    return JSON.parse(localStorage.getItem(this.filtersLocalStorageKey) || '{}')
  }

  saveFilters(filters: Filter[]): void {
    const activeFilters: { [key: string]: string[] } = {}

    filters.forEach((filter) => {
      if (filter.activeOptions.length) {
        activeFilters[filter.fieldId] = filter.activeOptions
      }
    })

    localStorage.setItem(
      this.filtersLocalStorageKey,
      JSON.stringify(activeFilters)
    )
  }
}
